<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :title="$t('merchantAccount.cancel_cash_out')" width="800px" class="diglog-card" :close-on-click-modal="false" @close="handleDialogClose">
      <div class="diglog-container">
        <div class="header-line" />
        <div class="section-title">
          {{ $t('merchantAccount.cancel_reason') }}:
        </div>
        <el-form ref="cancelForm" :model="cancelForm" :rules="cancelRules" status-icon label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item
                prop="reason"
              >
                <el-input
                  v-model="cancelForm.reason"
                  type="textarea"
                  :rows="6"
                  maxlength="200"
                  show-word-limit
                  autocomplete="off"
                  class="cancel-reason-input"
                  :placeholder="$t('merchantAccount.cancel_reason_placeholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="info" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mchWithdrawCancel } from '@/api/settlement/settlement'
import serviceConst from '@/const/serviceConst.json'

export default {
  name: 'Cancel_CashOut_Modal',
  data() {
    return {
      cancelForm: {
        reason: ''
      },
      cancelRules: {
        reason: [
          { required: true, message: this.$t('merchantAccount.cancel_reason_required'), trigger: 'blur' },
          { min: 1, max: 200, message: this.$t('merchantAccount.cancel_reason_length'), trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      submiting: false,
      withdrawId: null
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value, withdrawId = null) {
      this.dialogVisible = value
      this.withdrawId = withdrawId
    },
    onClickSubmitBtn() {
      this.$refs.cancelForm.validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = {
            withdraw_id: this.withdrawId,
            reason: this.cancelForm.reason
          }
          mchWithdrawCancel(params).then(res => {
            if (res.code === serviceConst.resCode.succ) {
              this.changModalStatus(false)
              this.$emit('cancel-success')
              this.$message.success('Cash out cancelled successfully')
            }
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    },
    handleDialogClose() {
      this.cancelForm = { reason: '' }
      this.withdrawId = null
      this.$nextTick(function() {
        this.$refs['cancelForm'].clearValidate()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section-title {
  color: #1D3A71;
  font-family: "Inter Tight";
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.cancel-reason-input {
  ::v-deep .el-textarea__inner {
    min-height: 150px !important;
    padding: 16px;
    font-size: 14px;
    line-height: 1.6;
    border: 1px solid #DCDFE6;
    border-radius: 8px;
    resize: none;

    &:focus {
      border-color: #1B4AEF;
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.35);
    }
  }

  ::v-deep .el-input__count {
    background: transparent;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }
}

.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  margin-top: 50px;
  height: 40px;
  border-radius: 4px;
}
.icon-question{
  margin-left: 4px;
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
</style>
